module.exports = __webpack_public_path__ + "img/logo2_.23734612.png";